/**
 * useSecrets Hook
 *
 * Custom React Query hook for fetching secrets list.
 */

import { useQuery } from '@tanstack/react-query';
import { secretService } from '../../../api/secret.service';
import type { SecretListQuery } from '../../../types/secret.types';

/**
 * Hook for fetching secrets
 * @param tenantId - Tenant ID
 * @param query - Optional query parameters (search, limit)
 */
export const useSecrets = (tenantId: string, query?: SecretListQuery) => {
  return useQuery({
    queryKey: ['secrets', tenantId, query],
    queryFn: async () => {
      const result = await secretService.listSecrets(tenantId, query);
      return result;
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
